import { defaultContent } from './defaultContent'

export type StorefrontContent = typeof defaultContent

/**
 * Deep-merge per-brand content overrides over the default (Zenzers) content.
 * Objects merge recursively; arrays and primitives REPLACE (so a brand can swap
 * the whole pillars list without element-wise merging surprises).
 */
export function mergeContent(overrides: unknown): StorefrontContent {
  return deepMerge(defaultContent, overrides) as StorefrontContent
}

function isPlainObject(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v)
}

function deepMerge(base: unknown, override: unknown): unknown {
  if (override === undefined || override === null) return base
  if (!isPlainObject(base) || !isPlainObject(override)) return override
  const out: Record<string, unknown> = { ...base }
  for (const key of Object.keys(override)) {
    out[key] = deepMerge((base as Record<string, unknown>)[key], override[key])
  }
  return out
}
